/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

/**
 * 
 */
export class LeiMonitoringControllerApi extends runtime.BaseAPI {

    /**
     * Initiates LEI status check for all organizations
     * LEI status check
     */
    async checkAllLEIStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/org/monitoring/lei-status-check`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Initiates LEI status check for all organizations
     * LEI status check
     */
    async checkAllLEIStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.checkAllLEIStatusesRaw(initOverrides);
        return await response.value();
    }

}
